import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { DialogProgrammatic as Dialog } from "buefy";
export interface ClientCredentials {
  /** TODO: Fill with attributes */
  placeholder: string;
}
export default class ClientCredentialsService {
  private httpClient = makeHttpClient();

  export(ids: number[], customerId: number) {
    const params = new URLSearchParams();
    if (ids.length == 0) {
      throw new Error("!!! NOTHING TO EXPORT !!!");
    } else {
      ids.map(id => {
        params.append("login_id", "" + id);
      });
      const url = `${
        env.customerUrl
      }export-credentials/?customer_id=${customerId}&${params.toString()}`;
      this.httpClient
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "UserCredentials.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(err => {
          Dialog.alert({
            title: "Export not possible",
            message:
              "There was an error exporting user credentials. Please contact your Customer Account Manager.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        });
    }
  }
  upload(file: File, customer_id: any) {
    /*
                Initialize the form data
            */
    const formData = new FormData();

    /*
               Add the form data we need to submit
           */
    formData.append("user_credentials", file);

    /*
         Make the request to the POST /single-file URL
       */
    //     return axios.post( '/api/customer/upload-credentials/',
    let url = `${env.customerUrl}upload-credentials/`;
    if (customer_id != null) {
      url = `${url}?customer_id=${customer_id}`;
    }
    return this.httpClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  getAll(customer_id: number, credential_id: any) {
    if (credential_id) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ClientCredentials>(
          env.customerUrl +
            "login-detail/" +
            credential_id +
            "/?id=" +
            customer_id
        )
      );
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<ClientCredentials>(
        env.customerUrl + "login-detail/" + "?id=" + customer_id
      )
    );
  }

  create(form: any) {
    const data = {
      customer: form.customer,
      country: form.country,
      stream: form.stream,
      scheme: form.scheme,
      username: form.username,
      password: form.password,
      additional_info: form.additional_info,
      website: form.website
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<ClientCredentials>(
        env.customerUrl + "login-detail/",
        data
      )
    );
  }

  update(form: any) {
    const data = {
      id: form.id,
      customer: form.customer,
      country: form.country,
      stream: form.stream,
      scheme: form.scheme,
      username: form.username,
      password: form.password,
      website: form.website,
      additional_info: form.additional_info
    };
    return _unwrapAxiosResponse(
      this.httpClient.put<ClientCredentials>(
        env.customerUrl + "login-detail/" + form.customer + "/",
        data
      )
    );
  }

  delete(cred_id: any) {
    const url = env.customerUrl + "login-detail/" + cred_id + "/";
    return _unwrapAxiosResponse(this.httpClient.delete<ClientCredentials>(url));
  }
}
